export default "__VITE_ASSET__a50e6147__"